module.exports = __webpack_public_path__ + "assets/wix-developers.svg?4d271187ed3a1e4934e15faf5b61408c";